import React, { PropsWithChildren } from 'react'
import { Skeleton } from '../components/Skeleton'
import { CustomErrorComponent } from '../components/Shared/CustomErrorComponent'
import { useAccountInitializer } from './useAccountInitializer'
import { useOAuthFlow } from './useOAuthFlow'

export const Guard: React.FC<PropsWithChildren> = ({ children }) => {
  const token = useOAuthFlow()
  const { isInitialized, error } = useAccountInitializer(token)

  if (!token) {
    return <Skeleton name='Connecting to auth...' />
  }

  if (error) {
    return (
      <CustomErrorComponent
        title='Authentication failed'
        message='Unable to verify your session. Please try again.'
        page='authentication'
        retryButtonText='Retry'
        onRetryClick={() => window.location.reload()}
      />
    )
  }

  return isInitialized && token ? <>{children}</> : <Skeleton name='Authenticating...' />
}
